// extracted by mini-css-extract-plugin
export default {"customScroll":"scrollbar_customScroll__KwuH3","customScrollLight":"scrollbar_customScrollLight__UlQtk"};